/**
 * @module events/types/mouseOver
 */

/**
 * @type {string}
 */
export default 'mouseover'
